import React, { useState } from "react";
import SortIcon from "@mui/icons-material/Sort";
import FilterListIcon from "@mui/icons-material/FilterList";
import SearchIcon from "@mui/icons-material/Search";
import TaskFilterDialog from "./filter/TaskFilterDialog";
import TaskSortDialog from "./sort/TaskSortDialog";
import { Typography, Chip, Box, IconButton } from "@mui/material";
import { useSelector } from "react-redux";
import { ReactComponent as TargetIcon } from "../../assets/icons/crosshair.svg";

const TaskListHeader = ({ title, listId, onSearchClick, isSearchActive }) => {
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showSortDialog, setShowSortDialog] = useState(false);
  const { sortOrder, filters } = useSelector((state) => state.user);
  const hideTitle = window.innerWidth < 360;

  // Targets list should have white text/icons
  const isTargetsList = listId === "targets" || listId === "all";

  // Count active filters
  const activeFilterCount = Object.values(filters?.labels || {}).filter(
    (f) => f?.include || f?.exclude,
  ).length;

  // Get current sort display name
  const getSortDisplayName = () => {
    if (sortOrder === "adaptive") return "Adaptive";
    const [optionId] = sortOrder?.split("-") || [];
    if (!optionId) return "Sort";
    return optionId.charAt(0).toUpperCase() + optionId.slice(1);
  };

  return (
    <div className="task-list-header">
      <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
        {isTargetsList && (
          <TargetIcon
            style={{
              width: 24,
              height: 24,
              stroke: "#ffa600", // $yellow
              fill: "transparent",
            }}
          />
        )}
        {!hideTitle && (
          <Typography variant="body1" className="task-list-header__title">
            {title}
          </Typography>
        )}
      </div>
      <Box
        className="task-list-header__controls-container"
        sx={{ display: "flex", gap: 1, alignItems: "center" }}
      >
        <Chip
          icon={<SortIcon sx={{ fontSize: 20 }} />}
          label={getSortDisplayName()}
          onClick={() => setShowSortDialog(true)}
          variant="outlined"
          size="medium"
          sx={{
            px: 1,
            py: 2,
            borderColor: isTargetsList ? "white !important" : "currentColor",
            color: isTargetsList ? "white !important" : "inherit",
            "& .MuiChip-label": {
              px: 1,
              fontSize: "0.9rem",
              color: isTargetsList ? "white !important" : "inherit",
            },
            "& .MuiChip-icon": {
              color: isTargetsList ? "white !important" : "inherit",
              fontSize: 20,
            },
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.1)",
            },
          }}
        />
        <Chip
          icon={<FilterListIcon sx={{ fontSize: 20 }} />}
          label={
            activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter"
          }
          onClick={() => setShowFilterDialog(true)}
          variant={activeFilterCount > 0 ? "filled" : "outlined"}
          size="medium"
          color={activeFilterCount > 0 ? "primary" : "default"}
          sx={{
            px: 1,
            py: 2,
            borderColor:
              activeFilterCount > 0
                ? undefined
                : isTargetsList
                  ? "white !important"
                  : "currentColor",
            color:
              activeFilterCount > 0
                ? undefined
                : isTargetsList
                  ? "white !important"
                  : "inherit",
            "& .MuiChip-label": {
              px: 1,
              fontSize: "0.9rem",
              color:
                activeFilterCount > 0
                  ? undefined
                  : isTargetsList
                    ? "white !important"
                    : "inherit",
            },
            "& .MuiChip-icon": {
              color:
                activeFilterCount > 0
                  ? undefined
                  : isTargetsList
                    ? "white !important"
                    : "inherit",
              fontSize: 20,
            },
            "&:hover": {
              bgcolor:
                activeFilterCount > 0 ? undefined : "rgba(255,255,255,0.1)",
            },
          }}
        />
        <IconButton
          onClick={onSearchClick}
          size="small"
          sx={{
            bgcolor: isSearchActive ? "rgba(255,255,255,0.2)" : "transparent",
            "&:hover": {
              bgcolor: "rgba(255,255,255,0.1)",
            },
          }}
        >
          <SearchIcon
            sx={{ fontSize: 28, fill: isTargetsList ? "white" : "inherit" }}
          />
        </IconButton>
      </Box>

      <TaskFilterDialog
        open={showFilterDialog}
        onClose={() => setShowFilterDialog(false)}
      />
      <TaskSortDialog
        open={showSortDialog}
        onClose={() => setShowSortDialog(false)}
      />
    </div>
  );
};

export default TaskListHeader;
